// extracted by mini-css-extract-plugin
export default {"GalleryGrid":"GalleryGrid_GalleryGrid__F3U2-","gridItem":"GalleryGrid_gridItem__j6IEN"};